// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"style_mainContainer__L4nsi","content":"style_content__uyhvd","videoImageContainer":"style_videoImageContainer__ZM3qB","videoImage":"style_videoImage__2TgVo"};